import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import News from './pages/News';
import Publication from './pages/Publications';
import ScrollToTop from './components/ScrollToTop';
import ReactGA from 'react-ga4';

// Initialize Google Analytics
ReactGA.initialize('G-ZC6P0T1V2F'); // Your GA4 Measurement ID

const PageTransitionWrapper = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.4 }}
  >
    {children}
  </motion.div>
);

const TrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    // Track pageview on route change
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search, 
      title: document.title // Adds page title to the event
    });
  }, [location]);

  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <TrackPageViews /> {/* Add this component */}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransitionWrapper><Home /></PageTransitionWrapper>} />
        <Route path="/news" element={<PageTransitionWrapper><News /></PageTransitionWrapper>} />
        <Route path="/publications" element={<PageTransitionWrapper><Publication /></PageTransitionWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <Navbar />
      <AnimatedRoutes />
      <ScrollToTop /> 
    </Router>
  );
};

export default App;